module.exports = __webpack_public_path__ + "static/media/OMI.c2b4a25b.png";